import { Injectable } from '@angular/core';
import {
    NavLinks,
    SideNavConfigurator,
} from '@montebravo.tech/design-system-navigation';
import { Observable, of } from 'rxjs';
import { AuthService, Roles } from '../../core/auth';
import { DepartmentsMap, navLinks } from './app-shell.config';

@Injectable()
export class AppShellService implements SideNavConfigurator {
    private pages: NavLinks;

    constructor(auth: AuthService) {
        const userRoles = auth.getRolesArray();
        const unsortedPages = userRoles.includes(Roles.SysAdmin)
            ? navLinks
            : navLinks.filter((navLink) =>
                  userRoles.some((userRole) =>
                      DepartmentsMap[navLink.id].roles.includes(userRole)
                  )
              );
        this.pages = unsortedPages.sort((link1, link2) =>
            link1.label < link2.label ? -1 : link1.label < link2.label ? 1 : 0
        );
    }

    getNavLinksSync(): NavLinks {
        return this.pages;
    }

    getNavLinks(): Observable<NavLinks> {
        return of(this.pages);
    }
}
